import type { GuidelineDayInfo, DayOfWeek } from "owa-graph-schema";
import React from "react";

export interface GuidelineEmployeeContextProps {
    officeDayPerPeriod: number;
    description: string;
    updateTime: string;
    createTime: string;
    creator: string;
    startDay: DayOfWeek;
    days: (GuidelineDayInfo | null)[];
    name: string;
    id: string;
}
// Context used to track the current employee guideline.
export const GuidelineEmployeeContext: React.Context<GuidelineEmployeeContextProps> = React.createContext<GuidelineEmployeeContextProps>({
    officeDayPerPeriod: 0,
    description: "",
    updateTime: "",
    createTime: "",
    creator: "",
    startDay: "None",
    days: [],
    name: "",
    id: "",
});

export const useGuidelineEmployeeContext = (): GuidelineEmployeeContextProps => React.useContext(GuidelineEmployeeContext);
